document.addEventListener('DOMContentLoaded', function () {
  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images() {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }
  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  class YgCardSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      const sectionId = this.getAttribute('data-section-id');
      const mobileSlides = parseFloat(this.getAttribute('data-mobile-slides')) || 1;
      const desktopSlides = parseFloat(this.getAttribute('data-desktop-slides')) || 3;
      const mobileSpacing = parseInt(this.getAttribute('data-mobile-spacing')) || 12;
      const desktopSpacing = parseInt(this.getAttribute('data-desktop-spacing')) || 24;
      
      const initSwiperInstance = () => {
        if (typeof Swiper === 'undefined') return;
        
        const swiperElement = document.querySelector(`#yg-card-grid-${sectionId} .yg-card-swiper`);
        if (!swiperElement) return;

        const paginationElement = document.querySelector(`#yg-card-grid-${sectionId} .swiper-pagination`);
        
        this.swiperInstance = new Swiper(swiperElement, {
          slidesPerView: mobileSlides,
          spaceBetween: mobileSpacing,
          pagination: paginationElement ? {
            el: paginationElement,
            type: 'bullets',
            clickable: true
          } : false,
          breakpoints: {
            1000: {
              slidesPerView: desktopSlides,
              spaceBetween: desktopSpacing
            }
          }
        });
      };

      if (typeof Swiper !== 'undefined') {
        initSwiperInstance();
      } else {
        window.addEventListener('load', initSwiperInstance);
      }
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }
  }

  if (!window.customElements.get('yg-card-swiper')) {
    window.customElements.define('yg-card-swiper', YgCardSwiper);
  }

})